export const activityStateEnum = [
    {
        stateId: 1,
        stateName: "已发布"
    },
    {
        stateId: 0,
        stateName: "已下架"
    },
    {
        stateId: -1,
        stateName: "已下架，请联系运营"
    }
]
